import { AxiosError } from "axios";

const useHandleError = () => {


  const handleResponseError = (error: AxiosError) => {
    if (!error.response) return;
    const errorResponse = error.response;
    return Promise.reject(error);
  };


  return { handleResponseError };
}

export default useHandleError;